import Vue from "vue";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./plugins/router";
import "./assets/styles/site.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";

Vue.use(VueGtag, {
    config: { id: "G-F2QZXD97FE" },
});

Vue.config.productionTip = false;

document.addEventListener("DOMContentLoaded", async function () {
    new Vue({
        router,
        render: (h) => h(App),
    }).$mount("#app");
});

